import { render, staticRenderFns, recyclableRender, components } from "./bigImg.vue?vue&type=template&id=232d7a1e&scoped=true&"
var renderjs
import script from "./bigImg.vue?vue&type=script&lang=js&"
export * from "./bigImg.vue?vue&type=script&lang=js&"
import style0 from "./bigImg.vue?vue&type=style&index=0&id=232d7a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../hbuilderX/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d7a1e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/bigImg.vue"
export default component.exports